<template>
    <div class="google-locate-button">
        <a class="btn btn-outline-primary" role="button" :href="propertyUrl" target="_blank">Locate Property &nbsp;<i class="fas fa-external-link-alt"></i></a>
    </div>
</template>

<script>
export default {
  props: ['pageData'],
  data() {
    return {
      propertyURLPrefix: 'https://google.com/maps/place/', // TODO: Use config value
    };
  },
  methods: {
    findAddress() {
      const summarySections = this.pageData.quote_summary.quote_summary_sections ? this.pageData.quote_summary.quote_summary_sections : null;

      // TODO: Hack - Searches quote_summary_sections object till it hits the 'Named Insured' > 'Address' property.
      if (summarySections) {
        for (let i = 0; i < summarySections.length; i += 1) {
          if (summarySections[i].label === 'Named Insured') {
            if (summarySections[i].content) {
              for (let y = 0; y < summarySections[i].content.length; y += 1) {
                if (summarySections[i].content[y].fields) {
                  for (let x = 0; x < summarySections[i].content[y].fields.length; x += 1) {
                    if (summarySections[i].content[y].fields[x].label === 'Address') {
                      return summarySections[i].content[y].fields[x].field_value || '';
                    }
                  }
                }
              }
            }
          }
        }
      }
      return ''; // Returns empty string as fail safe. Will still take agent to Google Maps if no address value is found.
    },
  },
  computed: {
    propertyUrl() {
      let propertyUrl = 'https://google.com/maps/place/';

      if (this.pageData.quote_summary.quote_summary_sections) {
        // TODO: Use a reliable source for street address.
        const urlEncodedGeoAddress = this.findAddress().split(' ').join('+');

        propertyUrl = `${this.propertyURLPrefix}${urlEncodedGeoAddress}`;
      }

      return propertyUrl;
    },
  },
};
</script>

<style scoped>
A.btn-outline-primary:hover {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/GoogleLocateButton.vue?69227b86